import { render, staticRenderFns } from "./FiltersLeftSidebar.vue?vue&type=template&id=65265656"
import script from "./FiltersLeftSidebar.vue?vue&type=script&lang=js"
export * from "./FiltersLeftSidebar.vue?vue&type=script&lang=js"
import style0 from "./FiltersLeftSidebar.vue?vue&type=style&index=0&id=65265656&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports